import type { Borrower, CaseRecord } from "@/lib/types";
import { acmeBorrower, acmeCase } from "./acme";
import { acmeEquipment, acmeRenewal } from "./acme-history";
import { betaBorrower, betaCase } from "./beta";
import { fooBorrower, fooCase } from "./foo";

export const seedBorrowers: Borrower[] = [acmeBorrower, betaBorrower, fooBorrower];

export const seedCases: CaseRecord[] = [acmeCase, betaCase, fooCase, acmeRenewal, acmeEquipment];

export { portfolioStats, integrations, policyLimits, reports, team } from "./platform";
